import React from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';

export default function IconConfirmed({
  className, height, title,
}: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M18.9998 4.00009C19.298 4.28761 19.3066 4.76241 19.0191 5.06058L7.78834 16.7073C7.59171 16.9112 7.26512 16.9112
      7.06849 16.7073L0.980563 10.3939C0.693042 10.0957 0.701675 9.62095 0.999844 9.33343C1.29801 9.04591 1.77281
      9.05454 2.06033 9.35271L7.06849 14.5464C7.26512 14.7503 7.59171 14.7503 7.78834 14.5464L17.9394 4.01938C18.2269
      3.72121 18.7017 3.71257 18.9998 4.00009Z</Icon>
  );
}

